import { Injectable } from '@angular/core';

export class  DemonstrativoQuitacao {
    anoBase: number = 2025;
    clienteId: number = 0;
    EmpresasIds: number[] = [];
}